export const ticketsEnLocale = {
  'tickets.yourTickets': 'Your Tickets',
  'tickets.eventDetails': 'Event Details',

  'tickets.Date': 'Date',
  'tickets.Hour': 'Hour',
  'tickets.Entry': 'Entry',
  'tickets.Section': 'Sector',
  'tickets.Row/Seat': 'Row/Seat',
  'tickets.correlative': 'Correlative',
  'tickets.purchaseCode': 'Purchase Code',
  'tickets.sell': 'Sell',
} as const;

export const ticketsEsLocale = {
  'tickets.yourTickets': 'Tus Tickets',
  'tickets.eventDetails': 'Detalles del Evento',

  'tickets.Date': 'Fecha',
  'tickets.Hour': 'Hora',
  'tickets.Entry': 'Entrada',
  'tickets.Section': 'Sector',
  'tickets.Row/Seat': 'Fila/Asiento',
  'tickets.correlative': 'Correlativo',
  'tickets.purchaseCode': 'Código de Compra',
  'tickets.sell': 'Vender',
} as const;
